import { gql } from '@apollo/client';

export const AscPeriodLockStatusFragment = gql`
  fragment AscPeriodLockStatus on AscPeriodLockStatus {
    fiscalYearId
    periodName
    isLocked
    monthLockStates {
      monthYear
      isLocked
    }
  }
`;
